class InterestMatchController {
  constructor(JPMCService, UserDataService, ResultsService) {
    // Dependencies
    this.ResultsService = ResultsService;
    this.userData = {
      interests: UserDataService.interests
    };

    this.interests = JPMCService.getJobById(this.jobId).interests;
    this.matchValue = '';
  }
  calculateMatch() {
    this.matchValue = this.ResultsService.calculateInterest(this.interests);
  }
}

InterestMatchController.$inject = ['JPMCService', 'UserDataService', 'ResultsService'];

export default InterestMatchController;



// WEBPACK FOOTER //
// ./src/components/interestMatch/interestMatch.controller.js